/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Nabídka partnera`
};

const da_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Partner tilbud`
};

const de_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Partnerangebot`
};

const en_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Partner offer`
};

const es_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Oferta de socio`
};

const fr_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Offre partenaire`
};

const hu_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Partnerajánlat`
};

const it_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Offerta partner`
};

const nl_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Partneraanbieding`
};

const pl_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Oferta partnerska`
};

const pt_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Oferta de parceiro`
};

const sv_partner_offer = /** @type {(inputs: {}) => string} */ () => {
	return `Partnererbjudande`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const partner_offer = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.partner_offer(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("partner_offer", locale)
	if (locale === "cs") return cs_partner_offer(inputs)
	if (locale === "da") return da_partner_offer(inputs)
	if (locale === "de") return de_partner_offer(inputs)
	if (locale === "en") return en_partner_offer(inputs)
	if (locale === "es") return es_partner_offer(inputs)
	if (locale === "fr") return fr_partner_offer(inputs)
	if (locale === "hu") return hu_partner_offer(inputs)
	if (locale === "it") return it_partner_offer(inputs)
	if (locale === "nl") return nl_partner_offer(inputs)
	if (locale === "pl") return pl_partner_offer(inputs)
	if (locale === "pt") return pt_partner_offer(inputs)
	return sv_partner_offer(inputs)
};